module.exports = __webpack_public_path__ + "img/CS-Lite-Plus-Assembly.3d2fcf51.jpg";